/* roster — funções exclusivas desta região. */
(function () {
  "use strict";

  window.DMSchoolSections = window.DMSchoolSections || {};
  window.DMSchoolSections.roster = function (ctx) {
    const {
      el: DMSchoolUi,
      b: DMSchoolUiAtual2,
      input,
      opt,
      table,
      csv,
      fmt,
      date,
      minutes,
      yearLabel,
      totals,
      reportSummary,
      goalText,
      status,
    } = window.DMSchoolUi;
    const {
      api,
      session,
      house,
      options,
      render,
      heading,
      toolbar,
      empty,
      saveForm,
      note,
      run,
      permitted,
    } = ctx;
    function students() {
      render(async (element) => {
        heading(element, "Alunos");
        if (options.onRegisterStudent && session.tipo !== "professor")
          toolbar(
            element,
            DMSchoolUiAtual2(
              "Cadastrar aluno",
              options.onRegisterStudent,
              "ds-button ds-primary",
            ),
          );
        const callResult = await api.call(
            session.tipo === "professor" ? "student-records" : "roster",
            {
              institution_id: house,
            },
          ),
          filters = DMSchoolUi("form", "ds-form ds-filter-bar"),
          search = input(filters, "name", "Nome", "search"),
          year = input(filters, "year", "Ano escolar", "select"),
          school = input(filters, "school", "Escola", "select"),
          active = input(filters, "active", "Status", "select"),
          access = input(filters, "access", "Último acesso", "select"),
          size = input(filters, "size", "Linhas por página", "select");
        opt(year, "", "Todos");
        for (const optionalValue of [
          ...new Set(
            callResult.students.map((student) => student.ano).filter(Boolean),
          ),
        ])
          opt(year, optionalValue, yearLabel(optionalValue));
        opt(school, "", "Todas");
        for (const optionalValue of [
          ...new Set(
            callResult.students
              .map((student) => student.escola)
              .filter(Boolean),
          ),
        ])
          opt(school, optionalValue, optionalValue);
        opt(active, "", "Todos");
        opt(active, "1", "Ativos");
        opt(active, "0", "Desativados");
        opt(access, "name", "Nome");
        opt(access, "recent", "Mais recentes");
        opt(access, "old", "Mais antigos");
        opt(size, "20", "20");
        opt(size, "50", "50");
        filters.onsubmit = (event) => event.preventDefault();
        element.append(filters);
        const list = DMSchoolUi("div");
        element.append(list);
        let page = 0;
        const draw = () => {
          list.replaceChildren();
          const rows = callResult.students
            .filter(
              (student) =>
                student.nome
                  .toLocaleLowerCase("pt-BR")
                  .includes(search.value.toLocaleLowerCase("pt-BR")) &&
                (!year.value || student.ano === year.value) &&
                (!school.value || student.escola === school.value) &&
                (!active.value || String(student.ativo) === active.value),
            )
            .sort((left, right) =>
              access.value === "name"
                ? left.nome.localeCompare(right.nome, "pt-BR")
                : (access.value === "recent" ? -1 : 1) *
                    String(left.last_logged || "").localeCompare(
                      String(right.last_logged || ""),
                    ) || left.nome.localeCompare(right.nome, "pt-BR"),
            );
          const limit = Number(size.value);
          page = Math.min(
            page,
            Math.max(0, Math.ceil(rows.length / limit) - 1),
          );
          if (!rows.length) return empty(list, "Nenhum aluno encontrado.");
          table(
            list,
            [
              "Aluno",
              "Ano escolar",
              "Turmas",
              "Situação",
              "Último acesso",
              ...(session.tipo === "professor" ? [] : ["Ações"]),
            ],
            rows.slice(page * limit, (page + 1) * limit).map((item) => {
              const values = [
                DMSchoolUiAtual2(
                  item.nome,
                  () => ctx.openStudentRecord(item.id, students),
                  "ds-record-link",
                ),
                yearLabel(item.ano),
                item.class_names || "Sem turma",
                Number(item.ativo) ? "Ativo" : "Desativado",
                item.last_logged
                  ? new Date(item.last_logged + "T12:00:00").toLocaleDateString(
                      "pt-BR",
                    )
                  : "Sem acesso",
              ];
              if (session.tipo !== "professor") {
                const actions = DMSchoolUi("div", "ds-row-actions");
                if (permitted("turmas"))
                  actions.append(
                    DMSchoolUiAtual2("Vincular turmas", () =>
                      studentClasses(item),
                    ),
                  );
                values.push(actions);
              }
              return values;
            }),
          );
          const prev = DMSchoolUiAtual2("Anterior", () => {
              page--;
              draw();
            }),
            next = DMSchoolUiAtual2("Próxima", () => {
              page++;
              draw();
            });
          prev.disabled = !page;
          next.disabled = (page + 1) * limit >= rows.length;
          toolbar(
            list,
            prev,
            DMSchoolUi(
              "span",
              null,
              "Página " + (page + 1) + " · " + rows.length + " alunos",
            ),
            next,
          );
        };
        for (const field of [search, year, school, active, access, size]) {
          field.oninput = () => {
            page = 0;
            draw();
          };
          field.onchange = field.oninput;
        }
        draw();
      });
    }
    function studentClasses(item) {
      render(async (value) => {
        heading(
          value,
          "Turmas de " + item.nome,
          "Selecione as turmas deste aluno. Seu cadastro e seu histórico de atividades permanecem preservados.",
        );
        toolbar(value, DMSchoolUiAtual2("Voltar aos alunos", students));
        const rows = await api.call("student-classes", {
          institution_id: house,
          student_id: item.id,
        });
        if (!rows.length)
          return empty(value, "Crie uma turma antes de vincular o aluno.");
        const form = DMSchoolUi("form", "ds-form"),
          choices = DMSchoolUi("div", "ds-class-choices");
        for (const optionalValue of rows) {
          const label = DMSchoolUi("label", "ds-choice"),
            check = DMSchoolUi("input");
          check.type = "checkbox";
          check.name = "class_ids";
          check.value = optionalValue.id;
          check.checked = !!Number(optionalValue.member);
          label.append(
            check,
            DMSchoolUi(
              "span",
              null,
              optionalValue.name +
                (optionalValue.school_year
                  ? " · " + optionalValue.school_year
                  : ""),
            ),
          );
          choices.append(label);
        }
        form.append(choices);
        saveForm(value, form, "Salvar turmas", async () => {
          const class_ids = new FormData(form).getAll("class_ids").map(Number);
          await api.call(
            "student-classes",
            {
              institution_id: house,
              student_id: item.id,
              class_ids,
            },
            true,
          );
          students();
          note("Turmas do aluno atualizadas.");
        });
      });
    }
    function classes() {
      render(async (element) => {
        heading(element, "Turmas");
        if (session.tipo !== "professor")
          toolbar(
            element,
            DMSchoolUiAtual2(
              "Criar turma",
              () => classForm(),
              "ds-button ds-primary",
            ),
          );
        const rows = await api.call("classes", {
          institution_id: house,
        });
        const filters = DMSchoolUi("form", "ds-form ds-filter-bar"),
          search = input(filters, "search", "Pesquisar turma", "search"),
          state = input(filters, "state", "Situação", "select");
        opt(state, "", "Todas");
        opt(state, "1", "Ativas");
        opt(state, "0", "Arquivadas");
        filters.onsubmit = (event) => event.preventDefault();
        element.append(filters);
        const list = DMSchoolUi("div");
        element.append(list);
        let page = 0;
        const draw = () => {
          list.replaceChildren();
          const filtered = rows.filter(
            (row) =>
              row.name
                .toLocaleLowerCase("pt-BR")
                .includes(search.value.toLocaleLowerCase("pt-BR")) &&
              (state.value === "" || String(row.active) === state.value),
          );
          page = Math.min(
            page,
            Math.max(0, Math.ceil(filtered.length / 20) - 1),
          );
          if (!filtered.length) return empty(list, "Nenhuma turma encontrada.");
          table(
            list,
            [
              "Turma",
              "Ano escolar",
              "Disciplina",
              "Alunos",
              "Situação",
              "Ações",
            ],
            filtered.slice(page * 20, (page + 1) * 20).map((item) => {
              const actions = DMSchoolUi("div", "ds-row-actions");
              actions.append(
                DMSchoolUiAtual2("Ver relatório", () =>
                  ctx.openClassRecord(item.id, classes),
                ),
              );
              if (session.tipo !== "professor")
                actions.append(
                  DMSchoolUiAtual2("Gerenciar alunos", () =>
                    classDetail(item.id),
                  ),
                );
              if (session.tipo !== "professor")
                actions.append(
                  DMSchoolUiAtual2("Editar", () => classForm(item)),
                  DMSchoolUiAtual2(
                    Number(item.active) ? "Arquivar" : "Reativar",
                    run(async () => {
                      await api.call(
                        "class-status",
                        {
                          id: item.id,
                          active: !Number(item.active),
                        },
                        true,
                      );
                      classes();
                    }),
                  ),
                );
              return [
                DMSchoolUiAtual2(
                  item.name,
                  () => ctx.openClassRecord(item.id, classes),
                  "ds-record-link",
                ),
                yearLabel(item.school_year),
                item.subject,
                item.students_count,
                Number(item.active) ? "Ativa" : "Arquivada",
                actions,
              ];
            }),
          );
          const prev = DMSchoolUiAtual2("Anterior", () => {
              page--;
              draw();
            }),
            next = DMSchoolUiAtual2("Próxima", () => {
              page++;
              draw();
            });
          prev.disabled = !page;
          next.disabled = (page + 1) * 20 >= filtered.length;
          toolbar(
            list,
            prev,
            DMSchoolUi(
              "span",
              null,
              "Página " + (page + 1) + " · " + filtered.length + " turmas",
            ),
            next,
          );
        };
        for (const field of [search, state]) {
          field.oninput = () => {
            page = 0;
            draw();
          };
          field.onchange = field.oninput;
        }
        draw();
      });
    }
    function classForm(item = {}) {
      render(async (value) => {
        heading(value, item.id ? "Editar turma" : "Nova turma");
        toolbar(value, DMSchoolUiAtual2("Voltar", classes));
        const form = DMSchoolUi("form", "ds-form");
        input(
          form,
          "name",
          "Nome da turma",
          "text",
          item.name,
          true,
        ).maxLength = 100;
        input(
          form,
          "school_year",
          "Ano / período",
          "text",
          item.school_year,
        ).maxLength = 60;
        input(form, "subject", "Disciplina", "text", item.subject).maxLength =
          100;
        saveForm(value, form, "Salvar turma", async (resultado) => {
          await api.call(
            "class-save",
            {
              ...resultado,
              id: item.id || 0,
              institution_id: house,
            },
            true,
          );
          classes();
        });
      });
    }
    function classDetail(value) {
      render(async (resultado) => {
        const [allResult, all] = await Promise.all([
          api.call("class", {
            id: value,
          }),
          session.tipo === "professor"
            ? Promise.resolve([])
            : api.call("candidates", {
                institution_id: house,
              }),
        ]);
        heading(
          resultado,
          allResult.name,
          [allResult.school_year, allResult.subject]
            .filter(Boolean)
            .join(" · "),
        );
        toolbar(resultado, DMSchoolUiAtual2("Voltar às turmas", classes));
        if (Number(allResult.active) && session.tipo !== "professor") {
          const form = DMSchoolUi("form", "ds-form ds-inline-form"),
            student = input(
              form,
              "student_id",
              "Adicionar aluno existente",
              "select",
              "",
              true,
            );
          opt(student, "", "Selecione o aluno");
          all
            .filter(
              (item) =>
                !allResult.members.some(
                  (itemAtual2) => String(itemAtual2.id) === String(item.id),
                ),
            )
            .forEach((item) =>
              opt(student, item.id, item.nome + " · " + item.ano),
            );
          saveForm(
            resultado,
            form,
            "Adicionar à turma",
            async (resultadoAtual2) => {
              await api.call(
                "member",
                {
                  id: value,
                  student_id: resultadoAtual2.student_id,
                  active: true,
                },
                true,
              );
              classDetail(value);
            },
          );
        } else if (!Number(allResult.active))
          empty(resultado, "Turma arquivada. A instituição pode reativá-la.");
        if (!allResult.members.length)
          return empty(resultado, "Nenhum aluno nesta turma.");
        table(
          resultado,
          ["Aluno", "Ano", "Turma"],
          allResult.members.map((item) => [
            DMSchoolUiAtual2(
              item.nome,
              () => ctx.openStudentRecord(item.id, () => classDetail(value)),
              "ds-record-link",
            ),
            yearLabel(item.ano),
            Number(allResult.active) && session.tipo !== "professor"
              ? DMSchoolUiAtual2(
                  "Retirar da turma",
                  run(async () => {
                    await api.call(
                      "member",
                      {
                        id: value,
                        student_id: item.id,
                        active: false,
                      },
                      true,
                    );
                    classDetail(value);
                  }),
                )
              : "Arquivada",
          ]),
        );
      });
    }
    return {
      students,
      classes,
      studentClasses,
    };
  };
})();
